/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetYoutubeIntegrationCuepointsCuepointsQueryResponse, GetYoutubeIntegrationCuepointsCuepointsQueryParams } from "../models/GetYoutubeIntegrationCuepointsCuepoints";

export function getGetYoutubeIntegrationCuepointsCuepointsUrl() {
  const res = { method: 'GET', url: `/youtube-cuepoints` as const }
  return res
}

/**
 * @description Read-only audit log of successful cuepoints, scoped to the caller client.
 * @summary List cuepoints for the authenticated client (paginated, filter, sort)
 * {@link /youtube-cuepoints}
 */
export async function getYoutubeIntegrationCuepointsCuepoints(params?: GetYoutubeIntegrationCuepointsCuepointsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetYoutubeIntegrationCuepointsCuepointsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetYoutubeIntegrationCuepointsCuepointsUrl().url.toString(), params, ... requestConfig })
  return res.data
}